<template>
    <div class="data-table">
        <div class="d-flex mx-12 py-4 data-summary">
            <p class="mx-4 mb-0">{{text1}}<strong>{{number1}}</strong></p>
            <p class="mx-4 mb-0">{{text2}}<strong>{{number2}}</strong></p>
            <p class="mx-4 mb-0">{{text3}}<strong>{{number3}}</strong></p>
        </div>
        <div class="padding-x">
            <v-data-table
                :headers="headers"
                :items="items"
                hide-default-footer
                multi-sort class="elevation-1"
            >
<!-- addition of icon in column -->
                <template v-slot:[`item.category`]="{ item }">
                    <slot name="category-icon"></slot>{{item.category}}
                </template>
                <template v-slot:[`item.quality`]="{ item }">
                    <slot name="quality-icon"></slot>{{item.quality}}
                </template>
                <template v-slot:[`item.relational`]="{ item }">
                    <slot name="relational-icon"></slot>{{item.relational}}
                </template>
<!-- link to more info -->
                <template v-slot:[`item.intervention`]="{ item }">
                    <a href="" class="primary_ cursor-pointer text-decoration-none">{{item.intervention}}</a>
                </template>
                <template v-slot:[`item.document`]="{ item }">
                    <a href="" class="primary_ cursor-pointer text-decoration-none">{{item.document}}</a>
                </template>
<!-- dots options -->
                <template v-slot:[`item.serviceprovider`]="{ item }">
                    <div class="d-flex justify-space-between align-center">
                        <p class="mb-0 primary_">{{item.serviceprovider}}</p>
                        <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn dark icon v-bind="attrs" v-on="on">
                                    <v-icon class="grey_">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-for="(item, i) in actions" :key="i" @click="item.click(item.title)" class="cursor-pointer last-child-red">
                                    <v-list-item-icon>
                                        <v-icon>{{item.icon}}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </template>
                <template v-slot:[`item.nameaccount`]="{ item }">
                    <div class="d-flex justify-space-between align-center">
                        <p class="mb-0 primary_">{{item.nameaccount}}</p>
                        <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn dark icon v-bind="attrs" v-on="on">
                                    <v-icon class="grey_">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item v-for="(item, i) in actions" :key="i" @click="item.click(item.title)" class="cursor-pointer last-child-red">
                                    <v-list-item-icon>
                                        <v-icon>{{item.icon}}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DataTable',
        props: ['text1', 'text2', 'text3', 'number1', 'number2', 'number3', 'headers', 'items'],
        data: () => {
            return {
                actions: [
                    { title: 'Editer', icon: 'mdi-square-edit-outline' },
                    { title: 'Ouvrir', icon: 'mdi-eye-outline' },
                    { title: 'Supprimer', icon: 'mdi-trash-can-outline' }
                ]
            }
        }
    }
</script>